import React from "react";
import { Save } from "lucide-react";
import ReportForm from "./components/ReportForm";

const EditReport = () => {
  return <ReportForm isEdit={true} submitIcon={Save} />;
};

export default EditReport;
